var module = angular.module('b2bLoginApp.directives');

module.directive('sdGoogleStars', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            rating: '=',
            size: '@'
        },
        templateUrl: '/account/company-profile-public/google-stars.html',
        link: function (scope) {
            scope.starSizeClass = 'star-' + (scope.size || 'sm');

            scope.filledWidth = function () {
                var rating = parseFloat(scope.rating);

                if (!rating || rating < 0) {
                    return '0%';
                }

                return (Math.min(rating, 5) / 5) * 100 + '%';
            };
        }
    };
});
